import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { axiosInstance } from 'api/axiosInstance';

import { resetStore } from 'modules/app/actions';
import { updateTokens } from 'modules/user/actions';

import { Router } from 'router';

import store, { persistor } from 'store';

import './App.scss';

axiosInstance.create(store, updateTokens, resetStore);

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router />
      </PersistGate>
    </Provider>
  );
};

export default App;
